import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { SecurityService } from 'app/services/security/security.service';

@Component({
  selector: 'app-guias',
  templateUrl: './guias.component.html',
  styleUrls: ['./guias.component.scss']
})
export class GuiasComponent {

  abrirPopUpGuia: boolean = false;
  constructor(private securityService: SecurityService,
    private router: Router,private loginService:LoginService) {}
  clickGuard(){
    this.loginService.clickGuard = true;
}
  AgregarGuia() {
    this.securityService.dataGuia = '';
    this.abrirPopUpGuia = true;
  }
  CerrarPopUpGuia() {
    this.abrirPopUpGuia = false;
  }

  Refresh() {
    this.router.navigate[("/guias/listado")];
  }
}
